/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * The REST resource kind, associated with HTTP Path prefix and Content-Type of API.
 */
export interface ResourceKind {
    /** The name of REST resource. Identify the HTTP path prefix for REST resource. */
    name: string;
    /**
     * The version of REST resource. Identify the Content-Type of API.
     *         Take a look to Zalando RESTful guidelines rule [114 MUST use media type versioning](https://opensource.zalando.com/restful-api-guidelines/#114).
     */
    version: number;
}
